<!-- src/components/SearchPage.vue -->
<template>
  <div class="search-page">
    <!-- 顶部搜索框 + 取消 -->
    <header class="search-header">
      <div class="input-wrapper">
        <input
          v-model="searchTerm"
          ref="searchInput"
          type="text"
          placeholder="请输入关键字"
          @keyup.enter="onSearch"
        />
        <!-- 右侧清空按钮，仅当有输入内容时显示 -->
        <button
          v-if="searchTerm"
          class="clear-input-btn"
          @click="onClearInput"
        >×</button>
      </div>
      <button class="cancel-btn" @click="onCancel">取消</button>
    </header>

    <!-- 初始态：历史 & 热门（仅在无输入且未展示结果时） -->
    <div v-if="!searchTerm && !showResults" class="search-init">
      <div class="section">
        <div class="section-title">
          历史搜索
          <button class="clear-btn" @click="clearHistory">🗑</button>
        </div>
        <div class="keyword-list">
          <button
            v-for="kw in history"
            :key="kw"
            class="keyword-item"
            @click="selectKeyword(kw)"
          >
            {{ kw }}
          </button>
        </div>
      </div>
      <div class="section">
        <div class="section-title">热门搜索</div>
        <div class="keyword-list">
          <button
            v-for="kw in hotKeywords"
            :key="kw"
            class="keyword-item"
            @click="selectKeyword(kw)"
          >
            {{ kw }}
          </button>
        </div>
      </div>
    </div>

    <!-- 搜索结果 -->
    <div v-if="showResults" class="search-results">
      <div class="results-list">
        <div
          v-for="item in results"
          :key="item.id"
          class="result-item"
        >
          <img :src="item.img" alt="封面" />
          <div class="info">
            <div class="name">{{ item.name }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
          <button class="play-btn" @click="playVideo(item.id)">
            播放
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchPage',
  data() {
    return {
      searchTerm: '',
      history: JSON.parse(localStorage.getItem('search_history') || '[]'),
      hotKeywords: [],
      showResults: false,
      results: []
    };
  },
  methods: {
    onCancel() {
      this.$router.back();
    },
    clearHistory() {
      this.history = [];
      localStorage.removeItem('search_history');
    },
    selectKeyword(kw) {
      this.searchTerm = kw;
      this.onSearch();
    },
    onClearInput() {
      this.searchTerm = '';
      this.showResults = false;
      this.results = [];
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    stripHtml(html) {
      return html.replace(/<[^>]+>/g, '').trim();
    },
    async fetchHotKeywords() {
      try {
        const json = await this.$fetchData('/api/video/hotSearch');
        if (json.code === 200 && Array.isArray(json.data)) {
          this.hotKeywords = json.data;
        }
      } catch (e) {
        console.error('拉取热门搜索失败：', e);
      }
    },
    async onSearch() {
      const term = this.searchTerm.trim();
      if (!term) return;
      // 更新历史记录
      this.history = this.history.filter(t => t !== term);
      this.history.unshift(term);
      localStorage.setItem('search_history', JSON.stringify(this.history));

      // 切换到结果视图
      this.showResults = true;
      this.results = [];

      try {
        const json = await this.$fetchData(
          `/api/video/search?pageSize=20&wd=${encodeURIComponent(term)}`
        );
        if (json.code === 1 && Array.isArray(json.list)) {
          this.results = json.list.map(item => ({
            id: item.vod_id,
            img: item.vod_pic,
            name: item.vod_name,
            desc: this.stripHtml(item.vod_content || item.vod_remarks || '')
          }));
        } else {
          console.error('搜索失败：', json.msg);
        }
      } catch (e) {
        console.error('搜索接口错误：', e);
      }
    },
    playVideo(id) {
      const msg = { action: 'playVideo', videoId: id };
      if (window.webkit?.messageHandlers?.nativeHandler) {
        window.webkit.messageHandlers.nativeHandler.postMessage(msg);
      } else if (window.Native?.postMessage) {
        window.Native.postMessage(JSON.stringify(msg));
      } else {
        console.log('播放模拟：', msg);
      }
    }
  },
  mounted() {
    this.$refs.searchInput.focus();
    this.fetchHotKeywords();
  }
};
</script>

<style scoped>
.search-page {
  padding: 12px;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: auto;
}
.search-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.input-wrapper {
  position: relative;
  flex: 1;
}
.search-header input {
  width: 100%;
  padding: 8px 32px 8px 12px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 1rem;
  outline: none;
}
.clear-input-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #888;
  cursor: pointer;
}
.cancel-btn {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 1rem;
  color: #1890ff;
  cursor: pointer;
}
.section {
  margin-bottom: 24px;
}
.section-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.clear-btn {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 1rem;
  color: #888;
  cursor: pointer;
}
.keyword-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
}
.keyword-item {
  margin: 4px 8px 4px 0;
  padding: 6px 12px;
  background: #f0f0f0;
  border: none;
  border-radius: 16px;
  font-size: 0.9rem;
  cursor: pointer;
}
.search-results .results-list {
  margin-top: 12px;
}
.result-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.result-item img {
  width: 80px;
  height: 106px;
  object-fit: cover;
  border-radius: 4px;
}
.info {
  flex: 1;
  margin: 0 12px;
}
.name {
  font-size: 1rem;
  color: #333;
  margin-bottom: 4px;
}
.desc {
  font-size: 0.85rem;
  color: #888;
  display: -webkit-box;           /* 创建伸缩盒子模型 */
  -webkit-box-orient: vertical;   /* 垂直排列子元素 */
  -webkit-line-clamp: 2;          /* 限制在 2 行 */
  overflow: hidden;               /* 超出隐藏 */
}
.play-btn {
  background: #1890ff;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}
</style>